export default __webpack_public_path__ + "static/media/tich_hop_firm_bank_en.7e714de3.png";